import { Box } from "@material-ui/core";
import { Field } from "react-final-form";

const HiddenInputRA = ({ label, source, initialValue }) => {
  return (
    <Field
      label={label}
      name={source}
      component={Box}
      initialValue={initialValue}
    />
  );
};

export default HiddenInputRA;
